export default "__VITE_ASSET__E$jidrvF__"